import { createPortal } from 'react-dom';
import type { Answers, Question } from '../types';

interface Props {
  questions: Question[];
  answers: Answers;
  current: number;
  open: boolean;
  onToggle: () => void;
  onJump: (i: number) => void;
}

export function NavBar({ questions, answers, current, open, onToggle, onJump }: Props) {
  const answered = questions.filter(q => answers.has(q.id)).length;
  const summary = questions.length ? `已答 ${answered} / ${questions.length}` : '无题目';

  const grid = questions.map((q, i) => {
    const st = answers.get(q.id);
    let cls = 'nav-item';
    if (st) cls += st.ok ? ' ok' : ' no';
    if (i === current) cls += ' current';
    return (
      <div key={i} className={cls} onClick={() => onJump(i)}>{i + 1}</div>
    );
  });

  return (
    <>
      {/* 桌面端折叠面板（移动端 CSS 隐藏，入口在底部操作栏） */}
      <div className={`nav-bar${open ? ' open' : ''}`}>
        <button className="collapse-toggle" onClick={onToggle}>
          <span className="collapse-title">题目导航</span>
          <span className="summary">{summary}</span>
          <span className="arrow">▾</span>
        </button>
        <div className="collapse-body">
          <div className="nav-title">点击数字跳转（绿色=答对，红色=答错）</div>
          <div className="nav-grid">{grid}</div>
        </div>
      </div>

      {/* 移动端底部抽屉：Portal 渲染到 body，脱离滚动容器，保证内部可正常滚动 */}
      {open && createPortal(
        <div className="sheet-wrap">
          <div className="sheet-backdrop" onClick={onToggle} />
          <div className="sheet-panel">
            <div className="sheet-head">
              <span className="sheet-title">题目导航</span>
              <button className="sheet-close" onClick={onToggle} aria-label="关闭">✕</button>
            </div>
            <div className="nav-title">{summary} · 点击数字跳转，也可左右滑动题目切换</div>
            <div className="nav-grid">{grid}</div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
